<script setup lang="ts">
defineProps<{
  label: string
  icon: string
}>()
</script>

<template>
  <div>
    <p class="section-label section-label--sm mb-2 flex items-center gap-1.5 px-0.5 font-bold">
      <i :class="icon" class="text-sm" aria-hidden="true" />
      {{ label }}
    </p>

    <div class="flex flex-col gap-2">
      <slot />
    </div>
  </div>
</template>
